module.exports = __webpack_public_path__ + "img/blockAB52.67f64436.svg";